import React from 'react';
import {
  ChildItem, ChildrenWrapper, Connector, ParentWrapper, TreeContainer,
} from './styles';

type HierarchyTreeProps = {
  parent: React.ReactNode;
  childrenNodes?: React.ReactNode[];
};

export const HierarchyTree: React.FC<HierarchyTreeProps> = ({ parent, childrenNodes = [] }) => (
  <TreeContainer>
    <ParentWrapper>{parent}</ParentWrapper>
    {childrenNodes.length > 0 && (
    <ChildrenWrapper>
      {childrenNodes.map((child, index) => (
        <ChildItem key={index}>
          <Connector />
          {child}
        </ChildItem>
      ))}
    </ChildrenWrapper>
    )}
  </TreeContainer>
);
